import React from "react";

interface IconProps {
    className?: string;
  }

const MonitorIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    id="Capa_1"
    enableBackground="new 0 0 512 512"
    height="512"
    viewBox="0 0 512 512"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g>
      <path d="m482 25h-452c-16.54 0-30 13.46-30 30v298c0 16.54 13.46 30 30 30h452c16.54 0 30-13.46 30-30v-298c0-16.54-13.46-30-30-30z" /><path d="m416 457h-81v-44h-158v44h-81c-8.28 0-15 6.72-15 15s6.72 15 15 15h320c8.28 0 15-6.72 15-15s-6.72-15-15-15z" />
    </g>
  </svg>
);

export default MonitorIcon;
